import { MARK_COLORS, TEXT_COLOR_MAP } from "@tiptap-content/util/colors"
import { Color } from "@tiptap/extension-text-style"
import type { Slice } from "@tiptap/pm/model"
import { Plugin } from "@tiptap/pm/state"
import { clampColor } from "../../util/clamp-color"

/** The allowed text colors. Reused as the underline colors by the underline picker. */
export const TEXT_COLORS: { name: string; color: string }[] = MARK_COLORS.map((name) => ({
  name: name[0]!.toUpperCase() + name.slice(1),
  color: TEXT_COLOR_MAP[name],
}))

// Cp mod: Clamp text colors to our allowed list when pasting.
export const CpColor = Color.extend({
  addProseMirrorPlugins() {
    return [...(this.parent?.() ?? []), new Plugin({ props: { transformPasted } })]
  },
})

function transformPasted(slice: Slice): Slice {
  slice.content.descendants((node) => {
    for (const mark of node.marks) {
      if (mark.type.name === "textStyle" && mark.attrs["color"]) {
        const clamped = clampColor(
          TEXT_COLORS.map((entry) => entry.color),
          mark.attrs["color"] as string,
        )
        // Mutating mark attrs directly for paste-transform convenience; marks
        // are nominally immutable but this is safe inside transformPasted.
        // @ts-expect-error mark.attrs has no index signature
        mark.attrs = { ...mark.attrs, color: clamped }
      }
    }
  })
  return slice
}
